module.exports = __webpack_public_path__ + "pc/img/magazine01.691c669a.jpg";